module.exports = __webpack_public_path__ + "static/media/net.8c1e8e71.png";